import PropTypes from 'prop-types'
import React from 'react'
import {
  MenuItem
} from 'components/Menu'
import {
  ModalMenu
} from 'components/Modal'

import classes from './TextUser.module.scss'

export const dragType = 'USER'

export class TextUser extends React.Component {
  static propTypes = {
    draggable: PropTypes.bool,
    menu: PropTypes.array,
    className: PropTypes.string,

    // User props
    id: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    profileKey: PropTypes.string,
    licenseType: PropTypes.number,
    isActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoaded: PropTypes.bool,
    profile: PropTypes.object,
  }

  renderName = () => {
    return this.props.name || <span className={classes.namePlaceholder} />
  }

  renderText = () => {
    let {
      draggable,
      menu,
      className,

      // User props
      id,
      email,
      name,
      profileKey,
      licenseType,
      isActive,
      isLoading,
      isLoaded,
      profile,

      ...restProps
    } = this.props

    let compClassName = classes.user
    if (className) compClassName += ' ' + className

    const Tag = menu
      ? 'a'
      : 'span'

    return (
      <Tag
        {...restProps}
        className={compClassName}
      >
        {this.renderName()}
      </Tag>
    )
  }

  render () {
    let {
      menu,

      name,
    } = this.props

    return menu ? (
      <ModalMenu>
        {this.renderText()}
        <MenuItem
          header
        >
          {name}
        </MenuItem>
        {menu.map((menuItem, index) => {
          const { title, ...menuItemProps } = menuItem

          return (
            <MenuItem
              {...menuItemProps}
              key={index}
            >
              {title}
            </MenuItem>
          )
        })}
      </ModalMenu>
    ) : (
      this.renderText()
    )
  }
}

export default TextUser

